import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import TemplateForm from "../../components/WhatsAppTemplateEditor";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useQuery = () => new URLSearchParams(useLocation().search);

const EditWhatsAppTemplate = () => {
  const history = useHistory();
  const { whatsappId, templateId } = useParams();
  const query = useQuery();
  const initialName = query.get("name") || "";
  const initialLanguage = query.get("language") || "";

  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadTemplate = useCallback(async () => {
    if (!whatsappId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.get(
        `/whatsapp/${whatsappId}/message-templates`
      );
      const rows = data?.data?.data || data?.data || [];
      const match = rows.find(
        (t) =>
          String(t.id) === String(templateId) ||
          (t.name === initialName && t.language === initialLanguage)
      );
      if (!match) {
        toast.error("Template não encontrado.");
        history.push("/whatsapp-templates");
        return;
      }
      setTemplate(match);
    } catch (err) {
      toastError(err);
      history.push("/whatsapp-templates");
    } finally {
      setLoading(false);
    }
  }, [whatsappId, templateId, initialName, initialLanguage, history]);

  useEffect(() => {
    loadTemplate();
  }, [loadTemplate]);

  return (
    <MainContainer>
      <MainHeader>
        <Title>Editar template WhatsApp (Meta)</Title>
        <MainHeaderButtonsWrapper>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push("/whatsapp-templates")}
          >
            Voltar
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>

      {loading && (
        <Box display="flex" justifyContent="center" p={4}>
          <CircularProgress />
        </Box>
      )}

      {!loading && template && (
        <TemplateForm
          mode="edit"
          whatsappId={whatsappId}
          templateId={templateId}
          initialTemplate={template}
        />
      )}
    </MainContainer>
  );
};

export default EditWhatsAppTemplate;
